import React from "react";
import DeleteSVG from "../../../components/svg/DeleteSVG";
import EditSVG from "../../../components/svg/EditSVG";

export default function QuizListTr({ row, handleDelete }) {
  const { id, question, video_title } = row || {};
  return (
    <tr key={id}>
      <td className="table-td">{question}</td>
      <td className="table-td">{video_title}</td>
      <td className="table-td flex gap-x-2">
        <DeleteSVG onClick={() => handleDelete(id)} />
        <EditSVG to={`/admin/editQuizze/${id}`} />
      </td>
    </tr>
  );
}
